module.exports = __webpack_public_path__ + "static/media/Product.a7169a90.svg";